import { render } from "./CustomerSelect.vue?vue&type=template&id=32c9a75f&scoped=true"
import script from "./CustomerSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&lang=js"

import "./CustomerSelect.vue?vue&type=style&index=0&id=32c9a75f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c9a75f"]])

export default __exports__